import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  IDCORREIOS_EXCLUIR_DEPENDENCIAS,
  IDCORREIOS_EXCLUIR,
} from '../../../services/meuCorreios';
import useFetch from '../../../components/hooks/useFetch';
import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';
import { useNavigate } from 'react-router-dom';
import Select from '../../../components/form/Select';
import { getIPAddress } from '../../../components/utils/GetIPAddress';

function FormExcluirConta({
  acaoCancelar,
  dados,
  tipoPessoa,
  inputRef,
  errors,
  ...rest
}) {
  const { t } = useTranslation();
  const [ipAddress, setIpAddress] = useState('');
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);

  const { request } = useFetch();
  const navigate = useNavigate();
  const [modalMotivoVisible, setModalMotivoVisible] = useState(false);
  const [motivoEscolhido, setMotivoEscolhido] = useState();

  const motivo = [
    {
      label: t('principal.forms.options.dissatisfaction'),
      valor: '1 - ' + t('principal.forms.options.dissatisfaction'),
    },
    {
      label: t('principal.forms.options.access_difficulties'),
      valor: '2 - ' + t('principal.forms.options.access_difficulties'),
    },
    { label: t('principal.forms.options.no_relevant_reason'), valor: '3 - ' + t('principal.forms.options.no_relevant_reason') },
  ];
  const handleEscolherMotivo = (event) => {
    setMotivoEscolhido(event.target.value);
  };
  const excluir = async (event) => {
    if (motivoEscolhido) {
      const enviar = {
        motivo: motivoEscolhido,
        tipoPessoa: tipoPessoa,
      };
      /* const { responsed } = await request(
        IDCORREIOS_EXCLUIR_DEPENDENCIAS(dados.idCorreios, enviar, ipAddress),
      );*/
      const { response } = await request(
        IDCORREIOS_EXCLUIR(dados.idCorreios, enviar, ipAddress),
      );
      if (response.ok) {
        abreAlertaDialog(t('principal.messages.success.account_deactivated'));
        setTimeout(() => {
          navigate('/abrirNovaSessao');
        }, 3000);
      }
    } else {
      abreAlertaDialog(t('principal.messages.validation.choose_reason'));
    }
  };
  const handleMotivo = () => {
    setModalMotivoVisible(true);
  };
  const fecharExcluir = (ev) => {
    ev.preventDefault();
    setModalMotivoVisible(false);
    acaoCancelar();
  };
  return (
    <>
      <div className="dialog-main">
        <div className="subtitulo-base">{t('principal.forms.messages.attention')}</div>

        <p>
          {t('principal.forms.messages.deactivation_warning')}
        </p>
      </div>

      <div className="dialog-footer">
        <button
          id="btn-excluir-conta"
          className="btn-txt btn-com-icone"
          onClick={handleMotivo}
        >
          {/*<i className="ic-excluir-circulo"></i>*/}
          {t('principal.forms.buttons.yes')}
        </button>
        <button className="btn-pre btn-fecha-dialog" onClick={fecharExcluir}>
          {t('principal.forms.buttons.no')}
        </button>
      </div>
      {modalMotivoVisible && (
        <div>
          <Select
            options={[
              { label: t('principal.forms.options.select'), value: '' },
              ...motivo.map((item) => ({
                value: item.valor,
                label: item.label,
              })),
            ]}
            name="motivo"
            inputref={inputRef}
            errors={errors}
            label={t('principal.forms.messages.reason_request')}
            id="motivo"
            onChange={handleEscolherMotivo}
            {...rest}
          />
          <div className="dialog-footer">
            <button
              id="btn-excluir-conta"
              className="btn-txt btn-com-icone"
              onClick={excluir}
            >
              <i className="ic-excluir-circulo"></i>
              {t('principal.forms.buttons.deactivate')}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
export default FormExcluirConta;
